import { request } from '@/utils/request';

export type ArticleClusteringPreferenceResponse = {
  articleClusteringEnabled: boolean;
};

export type UpdateArticleClusteringRequest = {
  articleClusteringEnabled: boolean;
};

/** Matches backend: PATCH /api/user/preferences/article-clustering/update/ */
export const ARTICLE_CLUSTERING_PREFERENCE_UPDATE_PATH =
  'user/preferences/article-clustering/update/';

export const makeApi = (instance = request) => ({
  updateArticleClustering: (data: UpdateArticleClusteringRequest) =>
    instance.patch<ArticleClusteringPreferenceResponse>(
      ARTICLE_CLUSTERING_PREFERENCE_UPDATE_PATH,
      data
    ),
});

export const api = makeApi();
